"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthDictionaries = exports.i18nAuthInstance = exports.AuthContextProvider = exports.AuthContext = exports.useAuthContext = void 0;
var react_1 = require("react");
var context_1 = require("./context");
Object.defineProperty(exports, "AuthContext", { enumerable: true, get: function () { return context_1.AuthContext; } });
var i18nAuthInstance_1 = __importDefault(require("./i18nAuthInstance"));
exports.i18nAuthInstance = i18nAuthInstance_1.default;
var provider_1 = require("./provider");
Object.defineProperty(exports, "AuthContextProvider", { enumerable: true, get: function () { return provider_1.AuthContextProvider; } });
var AuthDictionaries_1 = require("./AuthDictionaries");
Object.defineProperty(exports, "AuthDictionaries", { enumerable: true, get: function () { return AuthDictionaries_1.AuthDictionaries; } });
/**
 * Hook to get top level data in authentication workflow
 *
 * @category Hooks
 * @private
 * @internal
 */
var useAuthContext = function () {
    var context = (0, react_1.useContext)(context_1.AuthContext);
    if (context === null) {
        throw new Error('useAuthContext must be used within AuthContextProvider');
    }
    return context;
};
exports.useAuthContext = useAuthContext;
